import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

// Clear old auth tokens automatically once for the new deployment
const AUTH_VERSION = 'v1_auth_fix';
// if (typeof window !== 'undefined' && window.localStorage) {
// if (localStorage.getItem('trozzy_auth_version') !== AUTH_VERSION) {
//   localStorage.removeItem('token');
//   localStorage.removeItem('user');
//   localStorage.removeItem('adminToken');
//   sessionStorage.clear();
//   localStorage.setItem('trozzy_auth_version', AUTH_VERSION);
// }

// Handle lazy loading chunk failures due to new deployment
// window.addEventListener('error', (e) => {
//   const errorMsg = e.message || '';
//   if (/Loading chunk/i.test(errorMsg) || /ChunkLoadError/i.test(errorMsg)) {
//     window.location.reload();
//   }
// }, true);
// }


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
